import { Menu } from 'antd';
import React from 'react';
import './left-menu.less';
import { useStore } from '../../../store';
import RightOutlined from '@ant-design/icons/lib/icons/RightOutlined';
import DownOutlined from '@ant-design/icons/lib/icons/DownOutlined';
import { CompleteIcon, ProgressIcon } from '../Widget';
import { MenuInfo } from 'rc-menu/lib/interface';
import { useNavigate, useParams } from 'react-router-dom';
import { useCourseStore } from '../../courseStore';
interface ICourseOverviewProps {
  steps: string[];
  currentStep: number;
  topics: any[];
}

export interface ICourseStep {
  title: string;
  link: string;
  state: 'active' | 'completed' | 'none';
}
const gotoStep = (step: any) => {
  document?.querySelector('.course-body')?.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};
const StepItem = (prop: any) => {
  const { step } = prop;
  return (
    <div
      className={`step-dot ${step.state}-dot`}
      onClick={() => {
        if (step.state !== 'none') {
          gotoStep(step);
        }
      }}
    >
      {step.state === 'completed' && <CompleteIcon fill="#EE6E2F" />}
    </div>
  );
};
export const LeftMenu: React.FunctionComponent<ICourseOverviewProps> = ({
  steps,
  currentStep,
  topics,
}) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { language, getTopicState } = useStore();
  const { activeParagraph } = useCourseStore();
  const topicState = getTopicState(p_course);
  const navigate = useNavigate();

  // 使用 useMemo 同步计算选中状态，避免延迟
  const currentSelectedKey = React.useMemo(
    () => `${p_topic}-${activeParagraph}`,
    [p_topic, activeParagraph]
  );
  const currentOpenKey = React.useMemo(() => p_topic, [p_topic]);

  const [openKeys, setOpenKeys] = React.useState([currentOpenKey]);
  const [selectedKeys, setsSelectedKeys] = React.useState([currentSelectedKey]);
  const onMenu = (e: MenuInfo) => {
    const arr = e.key?.split('-');
    const _index = Number(arr[1]);
    const newSelectedKey = `${arr[0]}-${arr[1]}`;

    // 立即更新选中状态，避免延迟
    setsSelectedKeys([newSelectedKey]);
    if (arr[0] !== p_topic) {
      setOpenKeys([arr[0]]);
    }

    if (arr[0] !== p_topic) {
      if (arr[1] === '0') {
        document?.querySelector('.course-body')?.scrollTo({
          top: 0,
          left: 0,
          // behavior: 'smooth',
        });
      }
      navigate(`/${language}/course/${p_course}/${arr[0]}`);
      if (arr[1] !== '0') {
        setTimeout(
          () =>
            document
              .querySelectorAll('[data-paragraph]')
              [_index]?.scrollIntoView({ behavior: 'smooth' }),
          200
        );
      }
    } else {
      document
        .querySelectorAll('[data-paragraph]')
        [_index]?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const onOpenChange: any = (keys: any) => {
    if (keys.length > 0) {
      // 只允许一个子菜单展开，所以将openKeys设置为当前点击的子菜单的key
      setOpenKeys([keys[keys.length - 1]]);
    } else {
      // 如果没有子菜单展开，设置openKeys为空数组
      setOpenKeys([]);
    }
  };
  const expandIcon = ({ isOpen, isSubMenu }: any) =>
    isOpen ? <DownOutlined /> : <RightOutlined />;
  // ({ isSubMenu }) =>
  //   isSubMenu ? <RightOutlined /> : <DownOutlined />
  const [menuItems, setMenuItems] = React.useState<any[]>([]);

  React.useEffect(() => {
    const updatedSteps = steps.map((step: any, index: number) => ({
      ...step,
      state:
        topicState[index]?.state === 'completed'
          ? 'completed'
          : topicState[index]?.state === 'in-progress' || index === currentStep
          ? 'active'
          : 'none',
      children: topics[index]?.paragraphs?.map(
        (subItem: any, subIndex: number) => ({
          ...subItem,
          state:
            step.link === p_topic && subIndex === activeParagraph
              ? 'active'
              : topicState[index]?.paragraphStates?.[subIndex]?.state,
        })
      ),
    }));

    // 转换为Menu items格式
    const items = updatedSteps.map((step: any) => ({
      key: step.link,
      icon: <StepItem step={step} />,
      label: step.title,
      disabled: step.state === 'none',
      className: step.state,
      children: step?.children?.map((child: any, subIndex: number) => ({
        key: `${step.link}-${subIndex}`,
        label: (
          <>
            <span className="item-word">{child?.title}</span>
            <span className={`item-dot ${child?.state}`}>
              {child?.state === 'completed' && <CompleteIcon fill="#0B54A1" />}
              {child?.state === 'in-progress' && (
                <ProgressIcon fill="#F76D25" />
              )}
            </span>
          </>
        ),
        disabled: child?.state === 'not-start',
      })),
    }));

    setMenuItems(items);
  }, [steps, currentStep, topics, topicState, activeParagraph, p_topic]);

  // 单独监听路由变化，立即更新菜单状态，避免延迟
  React.useEffect(() => {
    setsSelectedKeys([currentSelectedKey]);
    setOpenKeys([currentOpenKey]);
  }, [currentSelectedKey, currentOpenKey]);

  return (
    <Menu
      className="left-menu"
      onClick={onMenu}
      openKeys={openKeys}
      selectedKeys={selectedKeys}
      mode="inline"
      expandIcon={expandIcon}
      onOpenChange={onOpenChange}
      items={menuItems}
    />
  );
};
